import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=0e5568e8&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=0e5568e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5568e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5568e8')) {
      api.createRecord('0e5568e8', component.options)
    } else {
      api.reload('0e5568e8', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=0e5568e8&scoped=true&", function () {
      api.rerender('0e5568e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/expiration-campaign/components/Messages.vue"
export default component.exports